import i18n from 'constants/translation/i18n';

const inventoryAreas = (t?: any) => {
  const entries = [
    {
      area: 'risks',
      title: t ? t('RISKS') : i18n.t('RISKS'),
      href: '/controlsAndRiskAllocation/risks'
    },
    {
      area: 'controls',
      title: t ? t('CONTROLS') : i18n.t('CONTROLS'),
      href: '/controlsAndRiskAllocation/controls'
    },
    {
      area: 'business_processes l4 l1',
      title: t ? t('BUSINESS_PROCESSESL1') : i18n.t('BUSINESS_PROCESSESL1'),
      href: '/controlsAndRiskAllocation/businessProcessesL1'
    },
    {
      area: 'business_processes l2',
      title: t ? t('BUSINESS_PROCESSESL2') : i18n.t('BUSINESS_PROCESSESL2'),
      href: '/controlsAndRiskAllocation/businessProcessesL2'
    },
    {
      area: 'business_processes l3',
      title: t ? t('BUSINESS_PROCESSESL3') : i18n.t('BUSINESS_PROCESSESL3'),
      href: '/controlsAndRiskAllocation/businessProcessesL3'
    },
    {
      area: 'business_processes l4',
      title: t ? t('BUSINESS_PROCESSES') : i18n.t('BUSINESS_PROCESSES'),
      href: '/controlsAndRiskAllocation/businessProcesses'
    }
  ];
  return entries;
};

export default inventoryAreas;
